import React from "react";
import {
  StyledMainContainer,
  StyledMainTextContainer,
} from "../constants/Styles";

const Work = () => {
  //const history = useHistory();
  //const isSmallScreen = window.screen.width < 800;
  //const containerHeight = isSmallScreen ? '13rem' : '21rem';
  //const imageHeight = isSmallScreen ? '12rem' : '20rem';
  //const hoverHeight = isSmallScreen ? '12.5rem' : '20.5rem';

  return (
    <StyledMainContainer>
      <StyledMainTextContainer>
        <h1>Coming soon...</h1>
      </StyledMainTextContainer>
    </StyledMainContainer>
  );
};

export default Work;
